import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    relatorios: null,
    beforeGen: null,
    isAllChecked: false,
}


const reporteReducer = createSlice({
    name: 'reporteReducer',
    initialState,
    reducers: {
        setRelatorio(state, action) {
            if (!state.relatorios) state.relatorios = []
            
            const { nomeCaderno, dataInicio, dataFim } = action.payload;

            // Evita duplicidade: Se já existe um relatório com mesmo nome e datas, substitui em vez de adicionar
            const index = state.relatorios.findIndex(r => 
                r.nomeCaderno === nomeCaderno && 
                r.dataInicio === dataInicio && 
                r.dataFim === dataFim
            );

            if (index !== -1) {
                state.relatorios[index] = action.payload;
            } else {
                state.relatorios.push(action.payload);
            }
        },
        checkRegistro(state, action) {

            let { registro,relatorio, value } = action.payload
            let indexRelatorio = state.relatorios.findIndex(rel => rel.id == relatorio.id)
            let index = state.relatorios[indexRelatorio].registros.findIndex(reg => reg.id == registro.id)
            state.relatorios[indexRelatorio].registros[index].checked = value


        },
        checkAllRegistro(state, action) {
            let {value,relatorio} = action.payload

            state.relatorios.forEach((rel,index) => {
                if(rel.id == relatorio.id) {
                    state.relatorios[index].allChecked = value
                    state.relatorios[index].registros.forEach((reg,jindex) => {
                        state.relatorios[index].registros[jindex].checked = value
                    })
                } 
            })
        },
        removeRegistro(state, action) {
            for (let relatorio of action.payload) {
               
                let indexRelatorio = state.relatorios.findIndex(rel => rel.id == relatorio.id)
                state.relatorios[indexRelatorio].registros.forEach((reg,index) => {
                    if(state.relatorios[indexRelatorio].registros[index].checked) state.relatorios[indexRelatorio].registros[index].removed = true
                    else state.relatorios[indexRelatorio].registros[index].removed = false
                   
                })
    
            }

        },
        removeRelatorio(state, action) {
            state.relatorios = state.relatorios.filter(rel => rel.id != action.payload.id)
        },
        rollbackRemoveRegistro(state, action) {
            for (let relatorio of action.payload) {
               
                let indexRelatorio = state.relatorios.findIndex(rel => rel.id == relatorio.id)
                state.relatorios[indexRelatorio].registros.forEach((reg,index) => {
                    state.relatorios[indexRelatorio].registros[index].removed = false
                })
    
            }
        },
        beforeGenState(state, action) {
            state.beforeGen = action.payload

        },
        rollBackSatate(state, action) {
            state.relatorios = state.beforeGen

        },
        clear(state, action) {
             state.relatorios = null
        },
        removeAllRelatorios(state, action) {
            state.relatorios = null
        },
    },
})

export const { setRelatorio, clear: clearReporte, removeRegistro,
    rollbackRemoveRegistro,
    beforeGenState,
    rollBackSatate,
    checkRegistro,
    unCheckRegistro,
    checkAllRegistro,removeRelatorio,
    removeAllRelatorios
} = reporteReducer.actions
export default reporteReducer.reducer